import { getUrlWithProtocol } from '@bbl-digital/snorre'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getBblSettings } from 'shared/store/bbl/selectors'
import { getUser } from 'shared/store/user/selectors'
import useRolesAccess from './useRolesAccess'
import { isBate } from 'shared/utils/theme'

const useAppRedirectHook = () => {
  const isReactNativeApp = window.ReactNativeWebView
  const { hasPortalAccessAllClients } = useRolesAccess()

  const { data } = useSelector(getUser)
  const settings = useSelector(getBblSettings)

  useEffect(() => {
    // Return if not bate and not react native app
    if (!isBate() || !isReactNativeApp || !data?.roles.length) return

    if (hasPortalAccessAllClients) return

    if (settings && settings.urls) {
      window.location.href =
        getUrlWithProtocol(settings?.urls.myPage) + '/info-app?noback=true' // Redirect to myPage
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, settings])
}
export default useAppRedirectHook
